<script setup lang="ts">
import ItemAvailability from '@/components/ItemAvailability.vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import type { ItemListTableInstance } from './types';

interface ItemListAvailabilityProps {
  row: ItemListTableInstance;
}

defineProps<ItemListAvailabilityProps>();
</script>

<template>
  <BaseFlexbox
    class="px-1 py-3 w-[7rem] h-full before:content-['']"
    direction="column"
    justify-content="start"
    align-items="start"
  >
    <Transition
      enter-from-class="opacity-0"
      enter-active-class="transition-opacity ease-out duration-300"
      enter-to-class="opacity-100"
    >
      <ItemAvailability :availabilityCount="row.availabilityCount" />
    </Transition>
  </BaseFlexbox>
</template>
